
<template>
  <div style="display: inline-block;">
    <span @click="addProduct()">
      <slot></slot>
    </span>
    <el-dialog
      v-if="dialogFormVisible"
      class="el-dialog-sm addcart"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :visible.sync="dialogFormVisible"
      width="90%"
      @close="init()"
    >
      <h3 class="text-center" style="margin-bottom: 15px;">{{title}}</h3>
      <el-row>
        <el-col :span="24" class="imgWall" v-if="form.picture" style="margin-bottom: 25px;">
          <img :src="form.picture" alt />
        </el-col>
      </el-row>

      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <div style="margin-bottom: 10px;" v-if="business.business_name">
          <p class="website-name">{{business.business_name}}</p>
          <p class="website-url" v-for="b in businessList">{{b}}</p>
        </div>
        <el-form-item label prop="website">
          <div class="websiteAppend">
            <!-- v-on:oneKeySuccess="getGoodDetail(product.good_id)" -->
            <!-- v-on:blur="getBusiness" -->
            <YueDanIpt
              v-on:input="inputSuccess"
              model="website"
              :object="form"
              v-on:oneKeySuccess="oneKeySuccess"
              placeholder="商品网址"
              :showOneKey="form.website &&( form.website.includes('us.puma.com') || checkWebsiteHasOneKey()  ) && business.business_id "
              :append="'一键获取'"
              :focus="true"
              :disabled="webdisabled"
            ></YueDanIpt>
            <div class="businessList" v-if="showBusinessList">
              <div class="business" v-for="item in showBusinessList" @click="selet(item)">
                <div>{{item.name}}</div>
                <div class="web">{{item.website}}</div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label prop="name">
          <YueDanIpt model="name" :object="form" placeholder="商品名称" :disabled="disabled"></YueDanIpt>
        </el-form-item>
        <el-form-item
          label
          prop="color"
          v-if="oneKeyList && oneKeyList.color_options.length>0 && oneKeyList.color_options[0] != ''"
        >
          <el-select
            v-model="form.color"
            placeholder="请选择颜色"
            style="width:100%;"
            @change="colorSelect"
          >
            <el-option
              v-for="item in oneKeyList.color_options"
              :key="item.color"
              :label="item.color"
              :value="item.color"
            >
              <!-- <img :src="item.color_url" alt=""> -->
              <span style="float: left;width:30px;margin-right:10px;">
                <img :src="item.color_url" alt />
              </span>
              <span style="float: left;width:auto;">{{ item.color }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label
          prop="color"
          v-if="oneKeyList  && oneKeyList.size_options.length>0 &&  oneKeyList.size_options[0] != ''"
        >
          <el-select
            v-model="form.size"
            placeholder="请选择尺寸"
            style="width:100%;"
            @change="sizeSelect"
          >
            <el-option
              v-for="item in oneKeyList.size_options"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label prop="spec">
          <YueDanIpt
            model="spec"
            v-if="!form.good_id || form.good_id == '0'"
            :object="form"
            placeholder="规格(颜色/尺码等，选填)"
            :disabled="disabled"
          ></YueDanIpt>
          <el-select
            v-model="choicesList"
            placeholder="请选择规格"
            v-if="form.good_id && form.good_id != '0'"
            style="width:100%;"
            @change="specSelect"
          >
            <el-option
              v-for="item in choices"
              :key="item.value"
              :label="(item.value.indexOf('oz') > -1 ? item.value+' | '+item.sku: item.value?item.value+' | '+item.sku:item.sku) "
              :value="item"
            >
              <span
                style="float: left;width:30px;margin-right:10px;"
                v-if="item.value && item.value.indexOf('oz') == -1"
                :class="{outStock:item.availability.indexOf('InStock') > -1 || item.availability.indexOf('LimitedAvailability') > -1 || item.availability.indexOf('OnlineOnly') > -1 || item.availability.indexOf('PreOrder') > -1 || item.availability.indexOf('PreSale') > -1? false:true}"
              >
                <img style="vertical-align: middle;" :src="item.color_image" alt />
                <div style="display: inline-block;margin-left:5px;">{{item.value}}</div>
                <div style="display: inline-block;">{{' | '+item.sku}}</div>
              </span>
              <span
                style="float: left;width:30px;margin-right:10px;"
                v-if="!item.value"
                :class="{outStock:item.availability.indexOf('InStock') > -1 || item.availability.indexOf('LimitedAvailability') > -1 || item.availability.indexOf('OnlineOnly') > -1 || item.availability.indexOf('PreOrder') > -1 || item.availability.indexOf('PreSale') > -1? false:true}"
              >{{item.sku }}</span>
              <span
                style="float: left;width:auto;"
                v-if="item.value.indexOf('oz') > -1"
                :class="{outStock:item.availability.indexOf('InStock') > -1 || item.availability.indexOf('LimitedAvailability') > -1 || item.availability.indexOf('OnlineOnly') > -1 || item.availability.indexOf('PreOrder') > -1 || item.availability.indexOf('PreSale') > -1? false:true}"
              >{{item.value + ' | ' + item.sku }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label prop="price">
              <YueDanIpt
                :dropdownList="CURRENCIES"
                v-on:dropdownChange="dropdownChange"
                model="price"
                :object="form"
                placeholder="价格"
                :append="currency.value"
                :reg="/^\d+\.?\d{0,2}$/"
                :disabled="disabled"
              ></YueDanIpt>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label prop="discounted_price">
              <YueDanIpt
                :reg="/^\d+\.?\d{0,2}$/"
                :dropdownList="CURRENCIES"
                v-on:dropdownChange="dropdownChange"
                model="discounted_price"
                :object="form"
                placeholder="折扣价"
                :append="currency.value"
              ></YueDanIpt>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="description" v-if="description">
        <h2>商品介绍</h2>
        <div class="discript" v-html="description"></div>
      </div>
      <el-checkbox
        v-if="fromGood && showSingleCart"
        v-model="checked"
        @change="change()"
        style="color:#666666;float: left;margin-bottom:10px;"
      >加入下单账户的购物车</el-checkbox>
      <div class="dialog-footer">
        <el-button
          class="block"
          type="primary"
          style="margin-bottom:50px;"
          @click="submit()"
          :disabled="outStock"
          :loading="loading"
        >{{outStock?'无 货':'确 定'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable eqeqeq */
import YueDanIpt from '../../../components/YueDanIpt'
import api from '../../../services/api.js'
import { CURRENCIES, ONEKEY_HOST } from '../../../services/constant'
let _ = require('lodash')
let $ = require('jQuery')

export default {
  name: 'AddProducts',
  props: ['product', 'isSingle', 'fromGood', 'description', 'copyform'],
  components: {
    YueDanIpt: YueDanIpt
  },
  computed: {
    taskInfo() {
      return this.$store.state.taskInfo
    }
  },
  created() {
    if (!this.product) {
      this.getSupportBusinessList()
      window.addEventListener('message', this.addGoodsByPlugin, false)
    } else {
      // this.getGoodDetail(this.product.good_id)
    }
  },
  data() {
    var checkPrice = (rule, value, callback) => {
      if (!this.form.price && !this.form.discounted_price) {
        callback(new Error('请输入价格或者折扣价'))
      } else {
        callback()
      }
    }
    var checkIsPrice = (rule, value, callback) => {
      if (value && (isNaN(value) || value < 0)) {
        callback(new Error('请输入正确的价格'))
      } else {
        callback()
      }
    }

    var checkIsWebsite = (rule, value, callback) => {
      if (!checkUrl(value)) {
        callback(new Error('请输入正确的网址'))
      } else if (!this.isSameBusiness()) {
        callback(new Error('商家不一致'))
      } else {
        callback()
      }
    }

    return {
      allowedWebsite: [], // 一键海涛
      choices: null,
      outStock: false, // 无货
      goodDetail: null,
      showSingleCart: false,
      choicesList: null,
      haveBussines: true,
      webdisabled: false,
      showOneKey: false,
      showBusinessList: null,
      oneKeyList: null,
      oneKeyTimes: 0,
      tempColor: '',
      tempSize: '',
      disabled: false,
      seletDisabled: false,
      checked: false,
      flag: null,
      CURRENCIES: CURRENCIES,
      dialogFormVisible: false,
      loading: false,
      errors: null,
      isEmptyErrors: true,
      title: '添加商品',
      business: {
        business_name: null,
        business_website: null
      },
      currency: {
        value: 'USD',
        symbol: '$'
      },
      businessList: [],
      specList: '',
      form: {
        name: '',
        website: '',
        color: '',
        size: '',
        spec: '',
        price: '',
        picture: '',
        onekey: 0,
        discounted_price: '',
        number: 1,
        currency: null,
        currency_symbol: null
      },
      rules: {
        name: [
          { required: true, message: '商品名称是必填项', trigger: 'blur' },
          { min: 1, max: 80, message: '商品长度为1-80个字符', trigger: 'blur' }
        ],
        website: [
          { required: true, message: '商品网址是必填项', trigger: 'blur' },
          { validator: checkIsWebsite, trigger: 'blur' },
          {
            min: 2,
            max: 2048,
            message: '网址长度为2-2048个字符',
            trigger: 'blur'
          }
        ],
        price: [
          { validator: checkPrice, trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' },
          { min: 0, max: 12, message: '价格不能超过12个字符', trigger: 'blur' }
        ],
        discounted_price: [
          { validator: checkIsPrice, trigger: 'blur' },
          { min: 0, max: 12, message: '价格不能超过12个字符', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'form.website': {
      handler(val, oldVal) {
        this.getBusiness(val)
      }
    }
  },
  mounted() {},
  methods: {
    // 判断是否具有一键识别的按钮
    checkWebsiteHasOneKey() {
      let _this = this
      for (let i = 0; i < this.allowedWebsite.length; i++) {
        const element = this.allowedWebsite[i].website
        if (_this.form.website.includes(element)) return true
      }
      return false
    },
    // 判断是否具有新一键识别的按钮
    checkWebsiteHasNewOneKey() {
      let _this = this
      for (let i = 0; i < this.allowedWebsite.length; i++) {
        const element = this.allowedWebsite[i].website
        if (_this.form.website.includes(element)) return true
      }
      return false
    },
    async getUserInfo() {
      if (this.$localStorage.get('token')) {
        try {
          let { body } = await api.getUserInfo(this)
          let result = body.result
          if (result.has_single == '1') {
            this.showSingleCart = true
          } else {
            this.showSingleCart = false
          }
        } catch (e) {}
      } else {
        this.showSingleCart = false
      }
    },
    dropdownChange(currency) {
      this.currency = Object.assign({}, currency)
    },
    addGoodsByPlugin(event) {
      if (event.source != window || !event.data.data) {
        return
      }
      let websites = event.data.data
      let tmp = []
      _.each(websites, async website => {
        if (website.business_website && website.items && website.items.length) {
          await this.getBusiness(website.business_website)
          _.each(website.items, item => {
            item.currency = website.currency
            item.currency_symbol = website.currency_symbol
            item.discounted_price = item.price
            this.form = item
            this.submitForm()
          })
        }
      })
    },
    async getSupportBusinessList(data) {
      let res = await api.getSupportBusinessList(this)
      let result = res.body.result
      this.allowedWebsite = result
    },
    inputSuccess(data) {
      this.showOneKey = false
      this.disabled = false
      this.oneKeyList = null
      this.form.color = ''
      this.form.size = ''
      // this.form.picture = ''
    },
    async getBusiness(website) {
      this.isEmptyErrors = true
      if (!checkUrl(website)) {
        this.showBusinessList = null
        this.oneKeyList = null
        this.form.color = ''
        this.form.size = ''
        // this.form.picture = ''
        this.showOneKey = false
        return
      }
      if (website) {
        let url = extractHostname(website)
        let res
        if (!this.fromGood) {
          res = await api.getListByWebsite(this, {
            website: url
          })
        } else {
          res = await api.getListByWebsite(this, {
            id: this.product.business_id
          })
        }

        if (res.body.result.length > 0) {
          this.haveBussines = true
          if (res.body.result.length == 1) {
            this.business = res.body.result[0]
            this.selet(res.body.result[0])
            this.showBusinessList = null
          } else {
            let showBusinessList = true
            this.showOneKey = false
            if (this.isSingle) {
              _.each(res.body.result, item => {
                if (
                  this.taskInfo &&
                  this.taskInfo.business &&
                  this.taskInfo.business.business_id == item.id
                ) {
                  this.business = item
                  showBusinessList = false
                  this.showBusinessList = null
                  return false
                }
              })
            } else {
              let list = await api.getCartList(this)
              _.each(res.body.result, item => {
                _.each(list.body.result, list => {
                  if (item.id == list.business_id) {
                    this.business = item
                    showBusinessList = false
                    this.showBusinessList = null
                  }
                })
              })
            }
            if (showBusinessList) {
              this.showBusinessList = res.body.result
              return
            }
          }
          if (this.business.enable_onekey == '1') {
            this.showOneKey = true
          } else {
            this.showOneKey = false
          }
          // eslint-disable-next-line no-unused-expressions
          (this.business.business_id = this.business.id),
            (this.business.business_name = this.business.name),
            (this.business.business_website = this.business.website)
          this.businessList = this.business.website.split(',')
          if (this.isSingle) {
            if (
              this.taskInfo &&
              this.taskInfo.business &&
              this.taskInfo.business.business_name != this.business.name
            ) {
              this.currency.value = this.business.default_currency
              _.each(this.CURRENCIES, item => {
                if (item.value == this.business.default_currency) {
                  this.currency.symbol = item.symbol
                }
              })
            }
          } else {
            this.currency.value = this.business.default_currency
            _.each(this.CURRENCIES, item => {
              if (item.value == this.business.default_currency) {
                this.currency.symbol = item.symbol
              }
            })
            let list = await api.getCartList(this)
            _.each(list.body.result, item => {
              if (item.business_name == this.business.name) {
                this.currency.value = item.currency
                this.currency.symbol = item.currency_symbol
              }
            })
          }
        } else {
          // this.business = {
          //   business_id: 0,
          //   business_name: url.replace('http://', '').replace('https://', ''),
          //   business_website: url
          // }
          // this.businessList = [url]

          this.haveBussines = false
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {
                message:
                  '此商家暂不支持代下单/代买，如有疑问可咨询客服或下单人.'
              }
            ]
          }
        }
      }
    },
    async selet(item) {
      this.business = item;
      (this.business.business_id = this.business.id),
        (this.business.business_name = this.business.name),
        (this.business.business_website = this.business.website)
      this.businessList = this.business.website.split(',')
      if (this.business.enable_onekey == '1') {
        this.showOneKey = true
      } else {
        this.showOneKey = false
      }
      if (this.isSingle) {
        if (this.taskInfo && !this.taskInfo.business) {
          this.currency.value = this.business.default_currency
          _.each(this.CURRENCIES, item => {
            if (item.value == this.business.default_currency) {
              this.currency.symbol = item.symbol
            }
          })
        }
        if (
          this.taskInfo &&
          this.taskInfo.business &&
          this.taskInfo.business.business_name != this.business.name
        ) {
          this.currency.value = this.business.default_currency
          _.each(this.CURRENCIES, item => {
            if (item.value == this.business.default_currency) {
              this.currency.symbol = item.symbol
            }
          })
        }
      } else {
        this.currency.value = this.business.default_currency
        _.each(this.CURRENCIES, item => {
          if (item.value == this.business.default_currency) {
            this.currency.symbol = item.symbol
          }
        })
        let list = await api.getCartList(this)
        _.each(list.body.result, item => {
          if (item.business_name == this.business.name) {
            this.currency.value = item.currency
            this.currency.symbol = item.currency_symbol
          }
        })
      }
      this.showBusinessList = null
    },
    colorSelect(item) {
      // 采用新一键下单逻辑
      if (this.checkWebsiteHasNewOneKey()) {
        this.tempColor = item
        // 判断是否需要从color二次获取
        if (
          this.oneKeyList.color_and_data_api &&
          this.oneKeyList.color_and_data_api.length > 0
        ) {
          let colorApiList = this.oneKeyList.color_and_data_api
          for (let i = 0; i < colorApiList.length; i++) {
            const element = colorApiList[i]
            if (element.color === item) {
              this.oneKeySuccess(element.data_api_url)
            }
          }
        } else {
          // 如果有choices的话,采用choice逻辑
          let choices = this.oneKeyList.choices
          let tempSizeList = []
          if (this.tempSize) {
            for (let i = 0; i < choices.length; i++) {
              const element = choices[i]
              if (element.color == item && element.size == this.tempSize) {
                this.form.spec = item + '/' + this.tempSize
                this.form.picture = element.images[0]
                  ? element.images[0]
                  : this.oneKeyList.images[0]
                break
              }
            }
          }
          // 修改size_options
          choices.forEach(element => {
            // 判断有无货备选
            if (element.color == item && element.is_out_of_stock == 0) {
              tempSizeList.push(element.size)
            }
          })
          this.oneKeyList.size_options = _.uniq(tempSizeList)
        }
      } else {
        _.each(this.oneKeyList.color_options, list => {
          if (item == list.color) {
            if (this.form.website.includes('us.puma.com')) {
              this.form.picture = list.color_url
            } else {
              this.form.website = list.url
              this.oneKeySuccess()
              return false
            }
          }
        })
        if (this.form.size) {
          this.form.spec = item + '/' + this.form.size
        } else {
          this.form.spec = item
        }
      }
    },
    sizeSelect(item) {
      if (this.checkWebsiteHasNewOneKey()) {
        let choices = this.oneKeyList.choices
        let tempColorList = []
        this.tempSize = item
        if (this.tempColor) {
          for (let i = 0; i < choices.length; i++) {
            const element = choices[i]
            if (element.color == this.tempColor && element.size == item) {
              this.form.spec = this.tempColor + '/' + item
              this.form.picture = this.oneKeyList.color_and_data_api
                ? this.oneKeyList.images[0]
                : element.images[0]
                ? element.images[0]
                : this.oneKeyList.images[0]
            }
          }
        } else {
        }
        // 修改color_options
        choices.forEach(element => {
          if (element.size == item && element.is_out_of_stock == 0) {
            tempColorList.push({
              color: element.color,
              color_url: element.color_image_url
            })
          }
        })
        this.oneKeyList.color_options = _.uniqBy(tempColorList, 'color')
      } else {
        if (this.form.color) {
          this.form.spec = this.form.color + '/' + item
        }
      }
    },
    specSelect(item) {
      if (
        item.availability.indexOf('InStock') > -1 ||
        item.availability.indexOf('LimitedAvailability') > -1 ||
        item.availability.indexOf('OnlineOnly') > -1 ||
        item.availability.indexOf('PreOrder') > -1 ||
        item.availability.indexOf('PreSale') > -1
      ) {
        this.outStock = false
      } else {
        this.outStock = true
      }
      if (item.value.indexOf('oz') > -1) {
        this.form.spec = item.value + ' | ' + item.sku
      }
      if (item.value && item.value.indexOf('oz') == -1) {
        this.form.spec = item.value + ' | ' + item.sku
      }
      if (!item.value) {
        this.form.spec = item.sku
      }
      this.form.price = item.price
      this.form.discounted_price = this.$decimalFormat((Number(this.form.price) * 0.8),2)
    },
    async oneKeySuccess(url = '') {
      if (this.loading) return
      this.loading = true
      this.$http
        .post(`${ONEKEY_HOST}/onekey.php`, { 
          website_url: url || this.form.website,
          business_tag: this.business.tag
        })
        .then(async res => {
          console.log(11112122, res.body.result, !!res.body.result)
          if(res.body.result && res.body.result.length == 0){
            this.loading = false
            this.isEmptyErrors = false
            // 重复请求计数器置0
            this.oneKeyTimes = 0
            this.oneKeyList = null
            this.errors = {
              business_name: [{ message: '请输入有效的商品网址.' }]
            }
            return
          }
          let firstPic = ''
          // 查找默认color_code 
          let defaultColorCode = new URLSearchParams(
            new URL(url || this.form.website).search.slice(1)
          ).get('color')
          if (res.body.result) {
            this.loading = false
            let result = res.body.result
            if(!result){
              this.loading = false
              this.errors = {
                business_name: [{ message: '请输入有效的商品网址.' }]
              }
            }
            // 如果没有拿到标题 则再次请求
            if (result.product_name === '') {
              this.oneKeyTimes++
              // if (this.oneKeyTimes <= 2) return this.oneKeySuccess()
            }
            // 如果有网址则覆盖
            if (url) {
              // console.log('not first')
              this.form.website = url
              let choices = result.choices
              let tempSizeList = []
              // 修改size_options
              choices.forEach(element => {
                // 判断有无货备选
                if (
                  element.color == this.tempColor &&
                  element.is_out_of_stock == 0
                ) {
                  tempSizeList.push(element.size)
                }
              })
              this.oneKeyList.size_options = _.uniq(tempSizeList)
              this.tempSize = ''
              this.form.size = ''
              this.form.picture = result.images[0]
              this.oneKeyList = { ...this.oneKeyList, ...result }
            } else {
              // console.log('first Time')
              this.disabled = true
              this.oneKeyTimes = 0 // 重试次数
              this.oneKeyList = result
              // this.form.color = result.selected_color
              // 判定是否属于新一键获取 
              if (this.checkWebsiteHasNewOneKey()) {
                if (result.choices && result.choices.length > 0) {
                  let sizeOptions = []
                  let colorOptions = []
                  let firstColor = ''
                  let choices = result.choices
                  for (let i = 0; i < choices.length; i++) {
                    const element = choices[i]
                    if (element.is_out_of_stock == 0) {
                      // 给初始有货产品图片
                      firstColor = firstColor || (defaultColorCode ? element.color_code == defaultColorCode ? element.color : '' : element.color)
                      firstPic =
                        firstPic || (element.images ? element.images[0] : '')
                      if(firstColor == element.color){
                        sizeOptions.push(element.size)
                      }
                      colorOptions.push({
                        color: element.color,
                        color_url: element.color_image_url
                      })
                    }
                  }
                  this.oneKeyList.size_options =
                    sizeOptions &&
                    sizeOptions.filter((x, index, self) => {
                      return self.indexOf(x) === index
                    })
                    // 去重
                  this.oneKeyList.color_options = _.uniqBy(
                    colorOptions,
                    'color'
                  )
                  // this.oneKeyList.color_options = colorOptions
                } else {
                  // 如果不是一键获取
                  this.oneKeyList.size_options = result.size_options
                  this.oneKeyList.color_options = result.color_options
                }
              } else {
                // 旧代码
                if (this.form.size) {
                  this.form.spec =
                    result.selected_color + ' / ' + this.form.size
                } else {
                  this.form.spec = result.selected_color
                }
                this.form.picture = result.image_options
                  ? result.image_options[0]
                  : []
              }
            }
            // 选颜色和尺码的第一个作为默认
            this.tempColor = this.oneKeyList.color_options
              ? this.oneKeyList.color_options[0].color
              : ''
            this.tempSize = this.oneKeyList.size_options
              ? this.oneKeyList.size_options[0]
              : ''
            // 如果有默认图片的话,则覆盖
            if (defaultColorCode) {
              for (let i = 0; i < result.choices.length; i++) {
                const element = result.choices[i]
                if (element.is_out_of_stock == 0 && defaultColorCode == element.color_code) {
                  firstPic = element.images ? element.images[0] : firstPic
                  this.tempColor = element.color
                  this.tempSize = element.size
                  break
                }
              }
            }
            this.form.size = this.tempSize
            this.form.color = this.tempColor
            this.form.spec = this.tempColor + '/' + this.tempSize
            this.form.name = result.product_name
            this.form.price = Number(result.choices[0].price) + ''
            this.form.discounted_price =
              Number(result.choices[0].discount_price) + ''
            this.form.picture =
              firstPic ||
              (this.oneKeyList.color_and_data_api
                ? this.oneKeyList.images[0]
                : result.choices[0].images[0]
                ? result.choices[0].images[0]
                : result.images[0])
            // console.log(this.form.picture)
          } else {
            this.loading = false
            this.isEmptyErrors = false
            // 重复请求计数器置0
            this.oneKeyTimes = 0
            this.oneKeyList = null
            this.errors = {
              business_name: [{ message: '请输入有效的商品网址.' }]
            }
          }
        })
    },
    async getGoodDetail(data) {
      this.loading = true
      let params = {
        id: data
      }
      let res = await api.getGoodDetail(this, params)
      if (res.body.status == 'ok') {
        this.loading = false
        this.goodDetail = res.body.result
        this.choices = res.body.result.choices
        if (!this.form.spec) {
          this.choicesList = res.body.result.choices[0]
          if (
            res.body.result.choices[0].availability.indexOf('InStock') > -1 ||
            res.body.result.choices[0].availability.indexOf(
              'LimitedAvailability'
            ) > -1 ||
            res.body.result.choices[0].availability.indexOf('OnlineOnly') >
              -1 ||
            res.body.result.choices[0].availability.indexOf('PreOrder') > -1 ||
            res.body.result.choices[0].availability.indexOf('PreSale') > -1
          ) {
            this.outStock = false
          } else {
            this.outStock = true
          }
          if (res.body.result.choices[0].value.indexOf('oz') > -1) {
            this.form.spec =
              res.body.result.choices[0].value +
              ' | ' +
              res.body.result.choices[0].sku
          }
          if (
            res.body.result.choices[0].value &&
            res.body.result.choices[0].value.indexOf('oz') == -1
          ) {
            this.form.spec =
              res.body.result.choices[0].value +
              ' | ' +
              res.body.result.choices[0].sku
          }
          if (!res.body.result.choices[0].value) {
            this.form.spec = res.body.result.choices[0].sku
          }
          this.form.price = res.body.result.choices[0].price
          this.form.discounted_price =  this.$decimalFormat((Number(this.form.price) * 0.8),2);
        } else {
          _.each(res.body.result.choices, item => {
            if (this.form.spec.indexOf(item.sku) > -1) {
              this.choicesList = item
              return false
            }
          })
        }
      }
    },
    isSameBusiness() {
      // if (this.taskInfo.business_name) {
      //   if (this.business.business_name !== this.taskInfo.business_name) {
      //     return false
      //   }
      // }
      return true
    },
    addProduct: function() {
      this.dialogFormVisible = true
      this.init()
      this.getUserInfo()
      if (this.copyform) {
        Object.assign(this.form, this.copyform)
        this.currency.value = this.copyform.currency || 'USD'
        this.currency.symbol = this.copyform.currency_symbol || '$'
        this.business.id = this.copyform.business_id
        this.form.id = null
        if (this.form.website) {
          this.getBusiness(this.form.website)
        }
        if (this.form.onekey == '1') {
          this.webdisabled = true
          this.oneKeySuccess()
        }
      }
      if (this.product) {
        Object.assign(this.form, this.product)
        this.getGoodDetail(this.product.good_id)
        this.currency.value = this.product.currency || 'USD'
        this.currency.symbol = this.product.currency_symbol || '$'
        this.business.id = this.product.business_id
        this.title = '编辑商品'
        if (this.form.website) {
          this.getBusiness(this.form.website)
        }
        if (this.form.onekey == '1') {
          this.webdisabled = true
          this.oneKeySuccess()
        }
        if (this.form.good_id > 0) {
          this.webdisabled = true
          this.disabled = true
          if (!this.fromGood) {
            this.seletDisabled = true
          } else {
            this.seletDisabled = false
          }
          // this.specList = []
          // if(this.form.spec.indexOf(',') > -1) {
          //   let arr = this.form.spec.split(",")
          //   _.each(arr,item => {
          //     this.specList.push({
          //       value: item
          //     })
          //   })
          //   this.form.spec = this.specList[0].value
          // }else{
          //   this.specList.push({
          //     value: this.form.spec
          //   })
          //   this.form.spec = this.specList[0].value
          // }
        } else {
          if (this.form.onekey == '1') {
            this.disabled = true
          } else {
            this.disabled = false
          }
        }
      }
    },
    init() {
      this.errors = null
      this.disabled = false
      this.flag = this.isSingle
      this.checked = false
      this.showOneKey = false
      this.oneKeyList = null
      this.form = {
        name: '',
        website: '',
        color: '',
        size: '',
        spec: '',
        picture: '',
        price: '',
        onekey: 0,
        discounted_price: '',
        number: 1
      }
      this.business = {
        business_name: null,
        business_website: null
      }
      this.isEmptyErrors = true
      this.currency.value = this.taskInfo.currency
      this.currency.symbol = this.taskInfo.currency_symbol
    },
    change() {
      this.flag = this.checked
    },
    updateTaskInfo() {
      if (
        this.taskInfo &&
        this.taskInfo.business &&
        this.taskInfo.business.business_name == this.form.business_name
      ) {
        this.taskInfo.business_id = this.business.business_id
        this.taskInfo.business_name = this.business.business_name
        this.taskInfo.business_website = this.business.business_website
        this.taskInfo.currency = this.currency.value
        this.taskInfo.currency_symbol = this.currency.symbol
        this.$store.commit('updateTaskInfo', this.taskInfo)
      }
    },
    submit() {
      let token = this.$localStorage.get('token')
      if (!token) {
        this.dialogFormVisible = false
        if (window.innerWidth <= 768) {
          this.$store.commit('showGlobalDialog', 'loginVisible')
        } else {
          window.location.href = '/login'
        }
        return
      }
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (valid) {
          this.submitForm()
        } else {
          return false
        }
      })
    },
    submitForm() {
      if (!this.haveBussines) {
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {
              message: '此商家暂不支持代下单/代买，如有疑问可咨询客服或下单人.'
            }
          ]
        }
        return
      }
      if (
        this.taskInfo.business_name &&
        this.taskInfo.business_name != this.business.business_name &&
        this.flag
      ) {
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {
              message:
                '下单人购物车不支持多个商家, 您可以先清空购物车,再添加新商家商品.'
            }
          ]
        }
        return
      }
      if (this.oneKeyList && !this.form.color) {
        this.isEmptyErrors = false
        this.errors = {
          business_name: [{ message: '商品颜色是必选项.' }]
        }
        return
      }
      if (this.oneKeyList && !this.form.size) {
        this.isEmptyErrors = false
        this.errors = {
          business_name: [{ message: '商品尺寸是必选项.' }]
        }
        return
      }
      if (this.form.discounted_price) {
        this.form.discounted_price = String(this.form.discounted_price)
      }
      if (!this.form.price) {
        this.form.price = this.form.discounted_price
      }
      this.form.discounted_price =
        String(this.form.discounted_price) || this.form.price
      this.form.business = this.business
      this.form.business_id = this.business.business_id
      this.form.business_name = this.business.business_name
      this.form.business_website = this.business.business_website
      this.form.currency = this.currency.value
      this.form.currency_symbol = this.currency.symbol
      this.form.spec=this.form.spec.replace(/\n/g,'')
      this.dialogFormVisible = false
      this.taskInfo.currency = this.currency.value
      this.taskInfo.currency_symbol = this.currency.symbol
      this.updateTaskInfo()
      let data = {}
      if (this.fromGood) {
        data = {
          form: this.form,
          isSingle: this.flag
        }
      } else {
        data = this.form
      }
      this.$emit('add', data)
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.addGoodsByPlugin)
  }
}

function extractHostname(url) {
  url = String(url)
  var hostname
  var protocol = url.match(/.*:\/\//) || []
  protocol = protocol[0] || ''
  var str = hostname
  if (url.indexOf('://') > -1) {
    hostname = url.split('/')[2]
  } else {
    hostname = url.split('/')[0]
  }

  // find & remove port number
  hostname = hostname.split(':')[0]
  // find & remove "?"
  hostname = hostname.split('?')[0]
  // if(hostname == 'www.nike.com' || hostname == 'nike.com') {
  //   if(url.indexOf("://") > -1){
  //     if(url.split('/')[2]){
  //       return protocol + hostname
  //     }else{
  //       return protocol + hostname
  //     }

  //   }else{
  //     if(url.split('/')[1]){
  //       str = url.split('/')[1]
  //       return protocol + hostname +'/'+str+'/'
  //     }else{
  //       return protocol + hostname
  //     }
  //   }

  // }
  return protocol + hostname
}

function checkUrl(urlString) {
  if (urlString) {
    // eslint-disable-next-line no-useless-escape
    var reg = /^((([hH][tT][tT][pP][sS]?|[fF][tT][pP])\:\/\/)?([\w\.\-]+(\:[\w\.\&%\$\-]+)*@)?((([^\s\(\)\<\>\\\"\.\[\]\,@;:]+)(\.[^\s\(\)\<\>\\\"\.\[\]\,@;:]+)*(\.[a-zA-Z]{2,4}))|((([01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}([01]?\d{1,2}|2[0-4]\d|25[0-5])))(\b\:(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]\d{4}|[1-9]\d{0,3}|0)\b)?((\/[^\/][\w\.\,\?\'\\\/\+&%\$#\=~_\-@]*)*[^\.\,\?\"\'\(\)\[\]!;<>{}\s\x7F-\xFF])?)$/
    return reg.test(urlString)
  }
  return false
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
span {
  cursor: pointer;
}
.website-name {
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
  text-align: left;
  word-break: break-all;
}
.website-url {
  font-size: 13px;
  color: rgba(102, 102, 102, 1);
  line-height: 18px;
  text-align: left;
  margin-bottom: 5px;
  word-break: break-all;
}
.businessList {
  position: absolute;
  top: 50px;
  z-index: 999;
  width: 100%;
  max-height: 500px;
  background-color: #ffffff;
  border-width: 0 1px 1px;
  border-color: #c6c9cb;
  border-style: solid;
  overflow: auto;
}
.business {
  cursor: pointer;
  // height: 50px;
  border-bottom: 1px solid #c6c9cb;
  width: 100%;
  display: block;
  font-size: 14px;
  padding: 10px;
  line-height: 28px;
  background: transparent;
  box-sizing: border-box;
  color: #606266;

  .web {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.business:hover {
  background-color: #333;
  color: #fff;
}

.description {
  padding: 10px;
  max-height: 130px;
  border: 1px solid #cdcdcd;
  overflow-y: auto;
  font-size: 14px;
  color: #666 !important;
  text-align: left;
  word-break: break-all;
  margin-bottom: 10px;

  h2 {
    font-size: 10px;
    margin-bottom: 20px;
    margin-top: 5px;
  }
}
.outStock {
  div {
    color: #c0c4cc !important;
  }
}
.imgWall {
  text-align: center;

  img {
    height: 135px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/components/AddProducts.vue